export const isValidMeaningfulData = (value) => {
    const trimmedValue = String(value || "").trim();
    if (!trimmedValue) return true;

    // Detect excessive repeated characters (3+ consecutive same char)
    if (/(.)\1{4,}/.test(trimmedValue)) return false;

    // Detect if too many special characters (>40% of length)
    const specialCharCount = (trimmedValue.match(/[^a-zA-Z0-9\s]/g) || []).length;
    if (specialCharCount > trimmedValue.length * 0.4) return false;

    // Detect if mostly just numbers/special chars with minimal letters
    const letterCount = (trimmedValue.match(/[a-zA-Z]/g) || []).length;
    if (letterCount < 2) return false;

    return true;
};
